import { render, staticRenderFns } from "./TripOrderDetails.vue?vue&type=template&id=37bc5902&scoped=true&"
import script from "./TripOrderDetails.vue?vue&type=script&lang=js&"
export * from "./TripOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc5902",
  null
  
)

export default component.exports